import React, { Suspense } from 'react';
import { Lazy } from '@root/src/web/components/Lazy';
import { isNPageOrHigherPageView, isValidContentType, isValidSection, isIOS9, isValidTag, } from '@frontend/web/components/SignInGate/displayRule';
import { initPerf } from '@root/src/web/browser/initPerf';
import { hasUserDismissedGateMoreThanCount } from '../dismissGate';
const SignInGateDesignOptVar5 = React.lazy(() => {
    const { start, end } = initPerf('SignInGateDesignOptVar5');
    start();
    return import(
    /* webpackChunkName: "SignInGateDesignOptVar5" */ '../gateDesigns/design-opt-test/SignInGateDesignOptVar5').then((module) => {
        end();
        return { default: module.SignInGateDesignOptVar5 };
    });
});
const canShow = (CAPI, isSignedIn, currentTest) => !isSignedIn &&
    !hasUserDismissedGateMoreThanCount(currentTest.variant, currentTest.name, 5) &&
    isNPageOrHigherPageView(3) &&
    isValidContentType(CAPI) &&
    isValidSection(CAPI) &&
    isValidTag(CAPI) &&
    !isIOS9();
export const signInGateComponent = {
    gate: ({ ophanComponentId, dismissGate, guUrl, signInUrl, abTest, isComment, }) => (React.createElement(Lazy, { margin: 300 },
        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
            React.createElement(SignInGateDesignOptVar5, { ophanComponentId: ophanComponentId, dismissGate: dismissGate, guUrl: guUrl, signInUrl: signInUrl, abTest: abTest, isComment: isComment })))),
    canShow,
};
